import React from "react";

const Blogs = () => {
  return (
    <div className="h-screen flex justify-center items-center">
      <h1 className="">Coming Soon</h1>
    </div>
  );
};

export default Blogs;
